const zIndex = {
  modal: 8,
  header: 7,
  breadcrumb: 6,
  sectionMenu: 6,
  faqMenu: 1,
} as const;

export default zIndex;
